
import { FlowRender } from "../flow-render";
import React from 'react';

class TextType extends React.Component {

  constructor(props) {
    super(props);
    this.style = {};
  }

  render = () => {
    const divStyle = {
      ...this.props.div_style,
    };

    let strings = [];
    if (typeof this.props.text === 'string'
      || React.isValidElement(this.props.text)) {
      strings.push(this.props.text);
    } else if (Array.isArray(this.props.text)) {
      strings = this.props.text;
    }
    return (
      <div style={divStyle}>
        { strings.map((text, index) => {
          return (
            <div style={this.props.titleTextStyle} key={index}>
              <span style={this.style}>{text}</span>
            </div>
          )
        })}
      </div>
    )
  }
}

class Text0 extends TextType {

  static STYLE = {
    color: "#000",
    fontFamily: "Poppins",
    fontSize: "1rem",
    fontWeight: "500",
  };

  constructor(props) {
    super(props);
    this.style = {
      ...Text0.STYLE,
      ...this.props.style,
    }
  }
}

class Text1 extends TextType {
  constructor(props) {
    super(props);
    this.style = {
      fontFamily: "Poppins",
      fontSize: "1.5rem",
      fontWeight: "500",
    };
    if (this.props.style) {
      this.style = {
        ...this.style,
        ...this.props.style,
      }
    }
  }
}

class TitleText extends TextType {
  constructor(props) {
    super(props);
    this.style = {
      fontFamily: "Poppins",
      fontSize: "2.5rem",
      fontWeight: "800",
    }
  }
}

class PathUndefined extends FlowRender {

  constructor() {
    super([]);
  }

  renderContent = url => {
    const text = "Undefined endpoint - " + url;
    return (
      <div>
        <TitleText text={text}/>
      </div>
    );
  };

  render = (component) => {
    return (
      <div style={{height: "20rem"}}>
      </div>
    );
  }
}

const TDA_FIRST_ENDPOINT = "invest_for";

export { PathUndefined, Text0, Text1, TitleText,
  TDA_FIRST_ENDPOINT };
